import { cn } from "@/lib/utils";

export const GlassCard = ({ className, children, glow = false, ...props }) => {
  return (
    <div
      className={cn(
        "relative overflow-hidden rounded-2xl bg-white/5 border border-white/10 backdrop-blur-xl shadow-[0_10px_40px_rgba(0,0,0,0.45)]",
        glow &&
          "shadow-[0_0_0_1px_rgba(34,211,238,0.22),0_18px_60px_rgba(34,211,238,0.10)]",
        className
      )}
      {...props}
    >
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(600px_circle_at_20%_0%,rgba(255,255,255,0.08),transparent_55%)]" />
      <div className="relative">{children}</div>
    </div>
  );
};
